import { EventPanelView } from '@mark43/cad-api';
import { useQuery } from '@tanstack/react-query';

export function useCachedEventPanelViewQuery(props: { eventId: number }) {
    return useQuery({
        queryKey: ['event-panel-view', props.eventId],
        queryFn() {
            return {} as EventPanelView;
        },
        cacheTime: Infinity,
        enabled: false,
    });
}
